<template>
  <div class="survey-step-one">
    <div class="py-4 flex flex-col gap-2">
      <aha-checkbox
        :checked="selectedChecks.includes('Grammar mistakes')"
        @change="toggleCheck('Grammar mistakes', $event)"
      >
        Grammar mistakes
      </aha-checkbox>
      <aha-checkbox
        :checked="selectedChecks.includes('Quiz time limit is too long or too short')"
        @change="toggleCheck('Quiz time limit is too long or too short', $event)"
      >
        Quiz time limit is too long or too short
      </aha-checkbox>
      <aha-checkbox
        :checked="selectedChecks.includes('Slides with too much text')"
        @change="toggleCheck('Slides with too much text', $event)"
      >
        Slides with too much text
      </aha-checkbox>
      <aha-checkbox
        :checked="selectedChecks.includes('Lack of interactive questions')"
        @change="toggleCheck('Lack of interactive questions', $event)"
      >
        Lack of interactive questions
      </aha-checkbox>
      <aha-checkbox
        :checked="selectedChecks.includes('Other')"
        @change="toggleCheck('Other', $event)"
      >
        Other
      </aha-checkbox>
    </div>
    <div class="check-button__wrapper">
      <aha-antd-button
        :key="selectedChecks.join('-')"
        variant="secondary"
        @click="onCheckButtonClicked"
        name="spellchecker-fake-door-check-button"
        v-aha-emit-action="{ user_input: selectedChecks }"
      >
        Check
      </aha-antd-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedChecks: [],
    }
  },
  methods: {
    toggleCheck(value, event) {
      if (event) {
        // Add the value if not already in the array
        if (!this.selectedChecks.includes(value)) {
          this.selectedChecks.push(value)
        }
      } else {
        // Remove the value if present
        this.selectedChecks = this.selectedChecks.filter((item) => item !== value)
      }
    },
    onCheckButtonClicked() {
      this.$emit('onCheckButtonClicked')
    },
  },
}
</script>

<style lang="scss" scoped>
.check-button__wrapper {
  @apply w-full text-right;
}
</style>
